import script from "./carousalCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./carousalCard.vue?vue&type=script&setup=true&lang=ts"

import "./carousalCard.vue?vue&type=style&index=0&id=bee11942&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bee11942"]])

export default __exports__